// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"8b676f86","309":"e2d782c8","483":"ec6b63d3","845":"9b4ff1f3","998":"2007def5"}[chunkId] + ".chunk.js";
};